var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transactions-filter left"
  }, [_c('h4', [_vm._v("Filter Results")]), _c('div', [_c('div', [_c('v-treeview', {
    attrs: {
      "selectable": "",
      "selection-type": 'leaf',
      "selected-color": "#000",
      "item-disabled": "locked",
      "items": _vm.items,
      "return-object": "",
      "open-all": ""
    },
    model: {
      value: _vm.selection,
      callback: function callback($$v) {
        _vm.selection = $$v;
      },
      expression: "selection"
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }